import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import AppPanel from '../fw/AppPanel.react';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import AddButton from '../fw/AddButton.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'invitationList.title', 'defaultMessage': 'Invitations'}
});

interface InvitationListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class InvitationList extends React.Component<InvitationListProps> {

    typeName = 'invitations';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    render() {
        let { user } = this.props;
        let list = user.organisation.invitations;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <div>
                    <PagingGrid
                        columns={['email', 'createdAt']}
                        edges={list}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        urlMapping={urlMapping} />

                    <AddButton metadata={type} organisationId={this.props.user.organisation.realId} parent={this.props.user.organisation} urlMapping={urlMapping} />
                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(InvitationList), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    invitations(first: $first, after: $after, before: $before, last: $last) {
                        edges {
                            node {
                                id,
                                email,
                                createdAt,
                                organisation_id,
                            }
                        },
                        pageInfo {
                            hasNextPage,
                            hasPreviousPage,
                            startCursor,
                            endCursor
                        }
                    }
                }
            }
        `,
    },
});
